import axios from 'axios';
import { withAuth } from '../middleware/withAuth';

// Tworzymy instancję API używaną w całej aplikacji
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// Interceptor do dodawania nagłówków autoryzacji do każdego żądania
api.interceptors.request.use(withAuth, (error) => Promise.reject(error));

// Interceptor do obsługi odświeżania tokenów
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Jeśli błąd 401 i nie próbowaliśmy jeszcze odświeżyć tokenu
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Wywołaj endpoint odświeżania tokenu (używa refresh tokenu z ciasteczka)
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/refresh-token`,
          {},
          { withCredentials: true }
        );
        
        // Zapisz nowy access token w localStorage
        const newAccessToken = response.data.accessToken;
        localStorage.setItem('accessToken', newAccessToken);

        // Ponów oryginalne żądanie z nowym tokenem
        originalRequest.headers.set('Authorization', `Bearer ${newAccessToken}`);
        return axios(originalRequest);
      } catch (refreshError) {
        // Błąd odświeżania oznacza, że użytkownik musi się zalogować ponownie
        localStorage.removeItem('accessToken');
        // Tutaj można by dodać event bus do komunikacji między komponentami
        // np. wyemitować zdarzenie 'auth:logout'
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
